import classNames from "classnames";
import Spinner from "./Spinner";

// Aligned with realnews-web's ui/Button (Figma _button set): primary / secondary
// / tertiary on the shared tokens, initial-case by default (opt into caps with
// uppercase).
function Button({
  className,
  variant = "primary",
  isLoading,
  isPending,
  label,
  children,
  uppercase = false,
  ...restProps
}) {
  const showLoading = restProps.isPending || isLoading || isPending;
  // While loading the label span is visually hidden (removed from the a11y tree),
  // so give the spinner an accessible name to keep the button labeled.
  const loadingLabel =
    restProps["aria-label"] ||
    (typeof children === "string" ? children : label) ||
    "Loading";
  return (
    <button
      aria-busy={showLoading || undefined}
      className={classNames(
        "relative grid min-h-10 shrink-0 items-center justify-center rounded-xs px-xl",
        "font-body text-sm font-medium leading-sm whitespace-nowrap",
        "cursor-pointer focus-ring",
        uppercase && "uppercase",
        "disabled:cursor-not-allowed disabled:opacity-50",
        variant === "primary" &&
          // Hover is a translucent ink overlay over the brand fill, as an ::after
          // so the fill token stays untouched and the label stays above it.
          `isolate bg-brand-blue text-text-reversed-light
           after:pointer-events-none after:absolute after:inset-0 after:-z-10 after:rounded-xs
           hover:after:bg-tint-700-default-light focus-visible:after:bg-tint-700-default-light
           dark:hover:after:bg-tint-700-default-dark dark:focus-visible:after:bg-tint-700-default-dark`,
        variant === "secondary" &&
          `bg-tint-900-default-light text-text-default-light
           hover:bg-tint-800-default-light focus-visible:bg-tint-800-default-light
           dark:bg-tint-900-default-dark dark:text-text-default-dark
           dark:hover:bg-tint-800-default-dark dark:focus-visible:bg-tint-800-default-dark`,
        variant === "tertiary" &&
          `bg-transparent text-text-default-light
           hover:bg-tint-900-default-light focus-visible:bg-tint-900-default-light
           dark:text-text-default-dark
           dark:hover:bg-tint-900-default-dark dark:focus-visible:bg-tint-900-default-dark`,
        className,
      )}
      {...restProps}
    >
      <span
        className={`col-span-full row-span-full flex items-center justify-center gap-sm ${
          showLoading ? "invisible" : "visible"
        }`}
      >
        {label || children}
      </span>
      {showLoading && (
        <Spinner
          size="sm"
          aria-label={loadingLabel}
          className="col-span-full row-span-full"
        />
      )}
    </button>
  );
}

export default Button;
